import { NavLink } from 'react-router';
import { useCan } from '../auth/permissions';
import { useTranslate } from '../i18n/useTranslate';
import { NAV_ITEMS } from './navigation';

/**
 * Sol menü (SEOAI-47). İzni olmayan öğe ÇİZİLMEZ; filtreleme tek yerde,
 * bildirimsel listeden gelir (ui/navigation.ts).
 */
export function MainNav() {
  const t = useTranslate();
  const can = useCan();

  const visible = NAV_ITEMS.filter((item) => item.permission === undefined || can(item.permission));

  // Tek öğe kalsa bile menü çizilir: kullanıcı nerede olduğunu görmeli.
  if (visible.length === 0) return null;

  return (
    <nav aria-label={t('nav.label')} className="mainnav">
      <ul>
        {visible.map((item) => (
          <li key={item.to}>
            <NavLink to={item.to}>{t(item.labelKey)}</NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
